import React, { useState, useEffect } from "react";
import { history } from "../../helpers";
import { connect } from "react-redux";
import { userActions } from "../../actions";
import * as QueryString from "query-string";
import { bcryptjs } from "bcryptjs";

function PasswordReset(props) {
  const { logout, location, editPassword } = props;
  const params = QueryString.parse(location?.search);

  const [status, setStatus] = useState("");
  const code = params.c;

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [badPassword, setBadPassword] = useState(false);

  var bcrypt = require("bcryptjs");
  var salt = bcrypt.genSaltSync(10);

  useEffect(() => {
    logout();
  }, []);

  const handleEmailChange = (e) => {
    const { name, value } = e.target;
    setEmail(value);
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPassword(value);
  };
  const handlePassword2Change = (e) => {
    const { name, value } = e.target;
    setPassword2(value);
  };

  const validatePassword = (e) => {
    const { name, value } = e.target;
    if (value.length < 8) {
      setStatus("pwd_too_short");
    } else {
      setStatus("");
    }
  };

  const submitRequest = (e) => {
    if (status === "pwd_too_short") return;
    e.preventDefault();
    if (password !== password2) {
      setStatus("pwd_no_match");
      return;
    }
    const user = { email: email, password: password, password2: password2 };
    editPassword(user, code);
    history.replace("/login?status=pwd_reset_submitted");
  };

  return (
    <>
      <div class="login">
        <span class="pwdMessage">
          Please provide your email address, then enter and confirm your new
          password below to reset:
        </span>
        <br />
        <br />
        <form class="ingestorForm">
          <table class="ingestorFormTable">
            <tr>
              <td class="formLabel">
                <label for="limit">Your email address:</label>
              </td>
              <td class="formInfo">
                <input
                  type="text"
                  name="groupName"
                  id="groupName"
                  onChange={handleEmailChange}
                ></input>
              </td>
            </tr>
            <tr>
              <td class="formLabel">
                <label for="limit">Enter a new password:</label>
              </td>
              <td class="formInfo">
                <input
                  type="password"
                  name="groupName"
                  id="groupName"
                  onBlur={validatePassword}
                  onChange={handlePasswordChange}
                ></input>
              </td>
            </tr>
            <tr>
              <td class="formLabel">
                <label for="limit">Enter again to confirm:</label>
              </td>
              <td class="formInfo">
                <input
                  type="password"
                  name="groupName"
                  id="groupName"
                  onChange={handlePassword2Change}
                ></input>
              </td>
            </tr>
            <tr>
              <td class="formLabel">&nbsp;</td>
              <td class="formInfo">
                <button class="submit" onClick={submitRequest}>
                  Submit
                </button>
              </td>
            </tr>
          </table>
        </form>
        {status === "pwd_too_short" && (
          <>
            <br />
            <span class="pwderrormessage">
              Minimum 8 characters.
            </span>
          </>
        )}
        {status === "pwd_no_match" && (
          <>
            <br />
            <span class="pwderrormessage">Passwords don't match.</span>
          </>
        )}        
      </div>
    </>
  );
}

function mapStateToProps(state) {
  const { authentication } = state;
  return {
    authentication,
  };
}

const actionCreators = {
  logout: userActions.logout,
  editPassword: userActions.editPassword,
};

const connectedPasswordReset = connect(
  mapStateToProps,
  actionCreators
)(PasswordReset);
export { connectedPasswordReset as PasswordReset };
